/** Company logo file under environment.imageLink (uploaded from the dashboard settings). */
export const COMPANY_LOGO_FILE = 'logo.png';

/** Static per-line wordmarks (white on transparent), shipped in src/assets/lines/. */
const LINE_LOGOS: Record<string, string> = {
  PCA: 'assets/lines/pca.png',
  SPARKE: 'assets/lines/sparke.png',
  TERRACE: 'assets/lines/terrace.png',
  MINIMAL: 'assets/lines/minimal.png',
};

export function lineLogoFor(line: string | null | undefined): string | null {
  return line ? LINE_LOGOS[line.trim().toUpperCase()] ?? null : null;
}
